import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, empty } from 'rxjs';
import {
  ICreditReferenceBody, IDownLoadLienRelease, IFinishCategory, InvoiceNumberBody, IPlaceOrderBody, ISampleCategoryBody, ISampleFinish,
  ISampleRequestGrid1, IThermalCalculator, BaseResponse
} from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SelfUtilityService {

  constructor(private httpClient: HttpClient) { }


  //#region Api endPoints

  public submitCreditReferenceRequest(body: ICreditReferenceBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.GET_CREDIT_REFERENCE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getFinishCategories(): Observable<Array<IFinishCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.GET_FINISH_CATEGORIES}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getSampleFinishes(finishSampleLevel1key: number): Observable<Array<ISampleFinish>> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.GET_SAMPLE_FINISHES}/${finishSampleLevel1key}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getGridDataByCategory(body: ISampleCategoryBody[]): Observable<Array<ISampleRequestGrid1>> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.GET_GRID_DATA_BY_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public placeSampleRequest(body: IPlaceOrderBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.PLACE_SAMPLE_REQUEST}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public downloadLienRelease(body: IDownLoadLienRelease): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.DOWNLOAD_LIEN_RELEASE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  getDetailsByInvoiceNumber(body: InvoiceNumberBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.GET_LIEN_RELEASE_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#region thermal calculator
  thermalCalculatorPayload(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.THERMAL_CALCULATE_PAYLOAD}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  getProjectSeries(productType): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.GET_PROJECT_SERIES}/${productType}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  thermalCalculateSubmit(body: IThermalCalculator): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SELF_UTILITY.THERMAL_CALCULATE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion
  //#endregion 
}
